const keys = {
  ARMAZEM: {
    key: 'ARMAZEM',
    description: 'Armazém',
    fieldValue: 'armazem',
  },
  CONTA_CONTABIL: {
    key: 'CONTA_CONTABIL',
    description: 'Conta contábil',
    fieldValue: 'contaContabil',
  },
  NATUREZA: {
    key: 'NATUREZA',
    description: 'Natureza',
    fieldValue: 'natureza',
  },
  CONDICAO_PAGAMENTO: {
    key: 'CONDICAO_PAGAMENTO',
    description: 'Condição de pagamento',
    fieldValue: 'condicaoPagamento',
  },
  CONTA_FINANCEIRA: {
    key: 'CONTA_FINANCEIRA',
    description: 'Conta financeira',
    fieldValue: 'contaFinanceira',
  },
  TIPO_COBRANCA: {
    key: 'TIPO_COBRANCA',
    description: 'Tipo de cobrança',
    fieldValue: 'tipoCobranca',
  },
  OBSERVACAO_INTERNA: {
    key: 'OBERVACAO_INTERNA',
    description: 'Observação interna',
    fieldValue: 'observacaoInterna',
  },
  CONTA_DESPESA: {
    key: 'CONTA_DESPESA',
    description: 'Conta de despesa',
    fieldValue: 'contaDespesa',
  },
  OPERACAO: {
    key: 'OPERACAO',
    description: 'Operação',
    fieldValue: 'operacao',
  },
  TIPO_COMPRA: {
    key: 'TIPO_COMPRA',
    description: 'Tipo de compra',
    fieldValue: 'tipoCompra',
  },
  SEGMENTO: {
    key: 'SEGMENTO',
    description: 'Segmento',
    fieldValue: 'segmento',
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
